var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalysisIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.647,
    height: 73.647,
    viewBox: "0 0 73.647 73.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_500-Planning",
    "data-name": "500-Planning",
    transform: "translate(0.545 0.545)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2118",
    "data-name": "Rectangle 2118",
    width: 28.701,
    height: 18.766,
    transform: "translate(21.929 0.955)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2119",
    "data-name": "Rectangle 2119",
    width: 28.701,
    height: 18.766,
    transform: "translate(0.955 52.837)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2120",
    "data-name": "Rectangle 2120",
    width: 28.701,
    height: 18.766,
    transform: "translate(42.902 52.837)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7990",
    "data-name": "Path 7990",
    d: "M7,31.143V17H49.428V31.143",
    transform: "translate(8.065 21.636)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_153",
    "data-name": "Line 153",
    y2: 18.766,
    transform: "translate(36.279 19.721)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysisIcon);
export default __webpack_public_path__ + "static/media/analysis-icon.a6d3689327799a2ddbd0f5de6d9b24a1.svg";
export { ForwardRef as ReactComponent };